import React, {useEffect, useMemo, useState} from 'react';
import DefaultLayout from "../components/core/DefaultLayout";
import {Box, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Select, Switch, TextField} from "@material-ui/core";
import {SearchOutlined, SettingsInputAntennaTwoTone} from "@material-ui/icons";
import {postData, fetchData} from "../helpers/utils";
import {Endpoint} from "../constants/enums";
import {API_URL} from "../config";
import ExhibitCard from "../components/Exhibits/ExhibitCard";
import ExhibitModal from "../components/Exhibits/ExhibitModal";
import Typography from "@material-ui/core/Typography";
import Pagination from "@material-ui/lab/Pagination";
import Dialog from '@material-ui/core/Dialog';
import zIndex from "@material-ui/core/styles/zIndex";

const enotita = {
  title: 'ΕΝΟΤΗΤΑ / ΘΕΜΑΤΙΚΗ ΚΑΤΗΓΟΡΙΑ', options: [
    {id: 0, value: '-'},
    {id: 1, value: 'Εργαλεία'},
    {id: 2, value: 'Φωτογραφία'},
    {id: 3, value: 'Είδη οικοσκευής'},
    {id: 4, value: 'Οικιακός εξοπλισμός'},
    {id: 5, value: 'Επαγγελματικός εξοπλισμός'},
    {id: 6, value: 'Ενδυμασία'},
    {id: 7, value: 'Αντικείμενα προσωπικής χρήσης'},
    {id: 8, value: 'Καρτ ποστάλ'},
    {id: 9, value: 'Βιβλίο'},
    {id: 10, value: 'Χάρτης'},
    {id: 11, value: 'Χειρόγραφα'},
    {id: 12, value: 'Έγγραφα'},
    {id: 13, value: 'Χαρτονόμισμα'},
    {id: 14, value: 'Ενδυμασία'},
  ]
}
const topos = {
  title: 'ΤΟΠΟΣ ΧΡΗΣΗΣ / ΠΡΟΕΛΕΥΣΗΣ', options: [
    {id: 0, label: '-'},
    {id: 1, label: 'Επιλογή 1a'},
    {id: 2, label: 'Επιλογή 2a'},
    {id: 3, label: 'Επιλογή 3a'},
    {id: 4, label: 'Επιλογή 4a'},
    {id: 5, label: '%'},
  ]
}

const closeImg = {cursor:'pointer', float:'right', marginTop: '5px', width: '20px'};

const FilterSelection = ({title, options, selected, setSelected, loading}) => {

  const handleChange = (event) => {
    if (event.target.value === 0)
      setSelected('')
    else
      setSelected(event.target.value)
  }

  return <><InputLabel id="demo-simple-select-label">{title}</InputLabel>
    <Select fullWidth={true} value={selected} onChange={handleChange} disabled={loading}>
      {options.map((option) => {
        return <MenuItem value={option.id} key={`${option.id}-${title}`}>{option.value}</MenuItem>
      })}
    </Select>
  </>
}

const FilterVocabularySelection = ({title, options, selected, setSelected, loading}) => {

  const handleChange = (event) => {
    if (!event.target.value)
      setSelected('')
    else
      setSelected(event.target.value)
  }

  return <><InputLabel id="demo-simple-select-label">{title}</InputLabel>
    <Select fullWidth={true} value={selected} onChange={handleChange} disabled={loading} style={{zIndex:1000}}>
      {options && options.map((option) => {
        return <MenuItem value={option.termId} key={`${option.termId}-${title}`}>{option.label}</MenuItem>
      })}
    </Select>
  </>
}

const FilterText = ({title, selected, setSelected, loading}) => {

  const handleChange = (event) => {
    if (event.target.value === 0)
      setSelected('')
    else
      setSelected(event.target.value)
  }

  return <><InputLabel id="demo-simple-select-label" style={{fontFamily:'"Ping"'}}>{title}</InputLabel>
    <TextField  style={{fontFamily:'"Ping"'}} fullWidth={true} value={selected} onChange={handleChange} disabled={loading}/>
  </>
}

function Evretirio() {

  const [selectedEnotita, setSelectedEnotita] = useState('')
  const [selectedTopos, setSelectedTopos] = useState('')
  const [selectedFreeText, setSelectedFreeText] = useState('')
  const [loading, setLoading] = useState(true)
  // const [composition, setComposition] = useState(false)

  const [resultVocabularies, setResultVocabularies] = useState([])
  const [resultFreeText, setResultFreeText] = useState([])
  const [toposVocabulary, setToposVocabulary] = useState([])

  const [result, setResult] = useState([])
  const [resultCount, setResultCount] = useState(0)

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)

  const [selectedItem, setSelectedItem] = useState(null)

  const propertyEnotita = useMemo(() => {
    const key = 'p:enotita-katigoria'
    const value = enotita.options.find((e) => e.id === selectedEnotita)?.value || ''
    return {key, value}
  }, [selectedEnotita])

  const propertyTopos = useMemo(() => {
    const key = 'p:toposxrisis'
    const value = toposVocabulary.find((e) => e.termId === selectedTopos)?.label || ''
    return {key, value}
  }, [selectedTopos])

  const propertyFreeText = useMemo(() => {
    return selectedFreeText
  }, [selectedFreeText])

  const propertySyllogi = useMemo(() => {
    const key = 'parent.uuid'
    const value = 'f68de965-8acd-49fa-9586-cab9f0bf9352'
    return {key, value}
  }, ['f68de965-8acd-49fa-9586-cab9f0bf9352'])

  const visibleFilters = useMemo(() => {
    return [propertyEnotita, propertyTopos]
  }, [propertyEnotita, propertyTopos])

  // ct:composition
  // container:museum-exhibit

  const handleToposVocabularyFetch = async () => {
    try {
      const res = await fetchData(`${API_URL}/vocabularies/50d8d6db-84f4-41e9-bb01-d428a606136b/terms/all`);
      setToposVocabulary([{termid:'0', label:'-'}, ...res]);
    } catch (e) {
      console.log(e)
    }
  }

  const handleSearch = (res) => {
    setResult(res)
    setLoading(false)
    setResultCount(res.length)
    setPage(1)
  }

  const handleVocabulariesSearch = async () => {
    setResultVocabularies([])
    const filters = visibleFilters?.filter((f) => f.value !== '')
    const payloadBody = {
      type: 1==0 ? 'ct:syllogi' : 'ct:tekmirio-pieria', propertyFilter: {
        logicalOperator: 'AND',
        valueFilters:
          filters.map((f) => {
            return {operator: 'LIKE', propertyKey: f.key, propertyValue: `%${f.value}%`}
          })
      }
    }
    try {
      //const res = await fetchData(`${API_URL}/containers/f68de965-8acd-49fa-9586-cab9f0bf9352`);
      //if (payloadBody.propertyFilter.valueFilters.length>0 ) {
        const res = await postData(`${API_URL}/public/containers/search_properties`,{...payloadBody});
        setResultVocabularies([...res])
        handleSearch([...res, ...resultFreeText])
      //} else {
      //  handleSearch([...resultFreeText])
      //}
    } catch (e) {
      console.log(e)
    }
  }

  const handleFreeTextSearch = async () => {
    setResultFreeText([])
    try {
      const filters = visibleFilters?.filter((f) => f.value !== '')
      if (selectedFreeText && selectedFreeText.length>0) {
        console.log("text: "+selectedFreeText);
        const res = await postData(`${API_URL}/public/containers/search?q=`+selectedFreeText,{});
        //if (res && res.content) {
        setResultFreeText([...res.content])
        if (filters.length>0)
          handleSearch([...resultVocabularies, ...res.content])
        else
          handleSearch([...res.content])
      }else {
        handleSearch([...resultVocabularies])
      }
    } catch (e) {
      console.log(e)
    }
  }



  useEffect(() => {
    handleVocabulariesSearch()
  }, [propertyEnotita])

  useEffect(() => {
    handleVocabulariesSearch()
  }, [propertyTopos])

  useEffect(() => {
    const timeOutId = setTimeout(() => handleFreeTextSearch(), 500);
    return () => clearTimeout(timeOutId);
  }, [propertyFreeText])

  useEffect(() => {
    handleToposVocabularyFetch()
  }, [])


  return <DefaultLayout
  title={'Ευρετήριο'} isLoading={loading} style={{position:'relative'}}>
    <Grid container spacing={2} alignContent={'center'} alignItems={'center'}>
      <Grid item xs={4}>
        <FilterSelection loading={loading} {...enotita} selected={selectedEnotita} setSelected={setSelectedEnotita}/>
      </Grid>
      <Grid item xs={4}>
        <FilterVocabularySelection loading={loading} title={topos.title} options={toposVocabulary}
        selected={selectedTopos} setSelected={setSelectedTopos}/>
      </Grid>
      <Grid item xs={4}>
        <FilterText loading={loading} title='ΑΝΑΖΗΤΗΣΗ' selected={selectedFreeText} setSelected={setSelectedFreeText}/>
      </Grid>
    </Grid>
    <Box mt={4} style={{zIndex:-1}}>
      <Grid container spacing={2} justifyContent={'center'} >
        {result?.slice((page-1)*pageSize, page * pageSize).map((exhibit) => {
            return exhibit && exhibit.uuid && <Grid item key={exhibit.uuid} xs={12} sm={6} md={3}>
              <ExhibitCard exhibit={exhibit} onclick={(item)=>{setSelectedItem(item)}}/>
            </Grid>
          })}
          {Math.ceil(resultCount/pageSize)>1 &&
          <Grid item xs={10} align={'center'}>
            <Pagination count={Math.ceil(resultCount/pageSize)} onChange={(ev,page)=>{setPage(page)}} />
          </Grid>
          }
      </Grid>
      <Dialog maxWidth={'lg'} scroll={'body'} open={selectedItem!=null} onClose={()=>{setSelectedItem(null)}}>
        {selectedItem && <ExhibitModal item={selectedItem} onClose={()=>{setSelectedItem(null)}}/> }
      </Dialog>
    </Box>
    {!loading && result?.length === 0 &&
      <Box mt={4} p={6} style={{zIndex:-1000}}>
        <Typography variant={'h4'} align={'center'}>Δεν υπάρχουν αποτελέσματα</Typography>
      </Box>
    }

  </DefaultLayout>;
}

export default Evretirio;
